export const REACT_BACKEND_URL = 'https://landing-backend-5pjg3ckx7a-ew.a.run.app/api';